<template>
    <div>
        <div class="text-subtitle-1 text-medium-emphasis">
            {{ label }}
        </div>
        <v-select
            class="inputfield"
            v-model:model-value="modelValue"
            autocomplete="new-password"
            :readonly="readOnly"
            :items="gemeindeCollection.getModels()"
            :loading="gemeindeIsLoading"
            item-title="gemeinde"
            item-value="gemeinde_id"
            :placeholder="$t('ort_waehlen')"
            :clearable="!readOnly"
            clear-icon="fas fa-times"
        >
        </v-select>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { OrtGemeindeCollection } from '@/models/OrtGemeinde'

/**
 * Gemeinde-Select by Ort:
 *
 * loads Gemeinde from /lookup/ortGemeinde,
 * filtered by a specific ort-id (property)
 */

const modelValue = defineModel<number | null>('modelValue')

const {
    ortId = null,
    readOnly = true,
    label,
} = defineProps<{
    ortId?: number | null
    readOnly?: boolean
    label?: string
}>()

const gemeindeCollection = new OrtGemeindeCollection()
const gemeindeIsLoading = ref(false)

const emit = defineEmits<{
    (e: 'update:model-value', gemeindeId: number | null | undefined): void
}>()

watch(
    () => ortId,
    (newVal, oldVal) => {
        if (newVal !== oldVal) {
            loadGemeinden({ ort_id: newVal || -1 })
        }
    },
)
onMounted(() => {
    if (ortId) {
        loadGemeinden({ ort_id: ortId })
    } else if (modelValue.value) {
        loadGemeinden({ gemeinde_id: modelValue.value })
    }
})

async function loadGemeinden(query: { [key: string]: string | number | null }) {
    gemeindeIsLoading.value = true
    await gemeindeCollection.query(query)
    if (gemeindeCollection.getModels().length === 1) {
        emit('update:model-value', gemeindeCollection.first()?.gemeinde_id)
    }
    gemeindeIsLoading.value = false
}
</script>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
.icon-margin {
    margin-left: 0.25rem;
}
</style>
